import { Default, Detail,  List, Create } from "./views";

const Module = {
	name: "campaignoperation",
	defaultRoutePath: "/campaigns/campaignoperation",
	menuItemScope: "campaign",
	menuItemName: "campaignOperations",

    routes: [
        {
            path: "/campaigns/campaignoperation",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
